import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { createWidget, actionGroup } from 'actions/editor';
import { useRouteMatch, useHistory } from "react-router-dom";
import { Nav, Tab, TabContainer, Button, Image, Fade } from 'react-bootstrap';

import { contentGrid } from './contentGrid';

import {
  IMAGE, VIDEO, BUTTON, TEXT, SHAPE, LINE, RECTANGLE,
  FORM, IFRAME, HTML, ANCHOR, MENU,
  SECTION, SECTION_COLUMN,
  CONTENT, EXTERNAL_FORM, FORM_STEP, CAROUSEL, ASSET, SEEK
} from 'constants/widgetTypes';
import { getBaseUrl } from "services/util";

import _ from 'lodash';
import cx from 'classnames';
import shortid from 'shortid';

import StoryboardContext from 'components/Storyboard/context';
import { MediaLibraryModal } from 'components/MediaLibrary';
import { MediaPaletteView } from "components/MediaLibrary/MediaPalette";
import { ExternalMediaPalette } from 'components/MediaLibrary/ExternalMediaPalette';
import { MediaUploadButton } from 'components/MediaLibrary';
import { Widgets } from '@paperflite-marketing/cleverstory-commons';
import { LiveElementsPalette } from './liveElements';
import { getPositionForNewWidget } from 'components/Editor/helper/layoutManager';

import { texts } from './text';
import { buttons } from './button';
import { forms } from './form';
import { menus } from './menu';
import { carousels } from './carousel';
import { seekBars, seekButtons } from './seek';
import { lines, shapes, socialIcons, generalIcons } from './shapes'

import { sections } from './section'

import styles from './palette.module.scss';
import { fetchCreatedForms } from 'actions/forms/forms';
import InfiniteScroll from 'components/InfiniteScroll';
import Tooltip from 'components/Tooltip';
import Truncate from "react-truncate";
import { inlineAssetCards } from './inlineAsset';

import { INTEGRATION_TYPES } from 'constants/integrationList';

export const PaletteContext = React.createContext({
  close: () => { }
});

export function Palette({ open, style, onClose, editorSession, defaultParent, storyboardType, ...rest }) {
  const [paletteContext, setPaletteContext] = React.useState({
    close: () => {
      onClose();
    }
  });

  const [activePane, setActivePane] = useState('text');

  return (
    <PaletteContext.Provider value={paletteContext}>
      <TabContainer id="widget_type_tabs" defaultActiveKey={'text'} transition={Fade} onSelect={(key) => {
        setActivePane(key);
      }}>
        <div className={styles.tabContainer}>
          <div className={styles.widgetTypes}>
            <Nav className={'flex-column'}>
              <Nav.Item>
                <Nav.Link eventKey={'text'}>Text</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'media'}>Media</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'button'}>Button</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'carousel'}>Carousel</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'seek'}>Seek</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'iframe'}>Embed</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'anchor'}>Anchor</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'shape'}>Shape</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'content'}>Asset Cards</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'section'}>Section</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'form'}>Forms</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'liveElements'}>Live Elements</Nav.Link>
              </Nav.Item>
              {storyboardType !== 'INTERACTIVE_CONTENT' &&
                <Nav.Item>
                  <Nav.Link eventKey={'Menu'}>Menu</Nav.Link>
                </Nav.Item>
              }
            </Nav>
          </div>
          <Tab.Content className={styles.tabContent}>
            <TextPalette editorSession={editorSession} defaultParent={defaultParent} />
            <MediaPalette editorSession={editorSession} defaultParent={defaultParent} />
            <ButtonPalette editorSession={editorSession} defaultParent={defaultParent} />
            <CarouselPalette editorSession={editorSession} defaultParent={defaultParent} />
            <Seek editorSession={editorSession} defaultParent={defaultParent} />
            <EmbedPalette editorSession={editorSession} defaultParent={defaultParent} />
            <AnchorPalette editorSession={editorSession} defaultParent={defaultParent} />
            <ShapePalette editorSession={editorSession} defaultParent={defaultParent} />
            <ContentGridPalette editorSession={editorSession} defaultParent={defaultParent} />
            <SectionPalette editorSession={editorSession} defaultParent={defaultParent} />
            <FormsPalette editorSession={editorSession} defaultParent={defaultParent} />
            <LiveElementsPalette editorSession={editorSession} defaultParent={defaultParent} active={activePane === 'liveElements'} />
            <MenusPalette editorSession={editorSession} defaultParent={defaultParent} active={activePane === 'Menu'} />
          </Tab.Content >
        </div >
      </TabContainer >
    </PaletteContext.Provider >
  );
}

export function GatingPalette({ open, style, onClose, editorSession, defaultParent, ...rest }) {
  const [paletteContext, setPaletteContext] = React.useState({
    close: () => {
      onClose();
    }
  });

  const [activePane, setActivePane] = useState('text');

  return (
    <PaletteContext.Provider value={paletteContext}>
      <TabContainer id="widget_type_tabs" defaultActiveKey={'text'} transition={Fade} onSelect={(key) => {
        setActivePane(key);
      }}>
        <div className={styles.tabContainer}>
          <div className={styles.widgetTypes}>
            <Nav className={'flex-column'}>
              <Nav.Item>
                <Nav.Link eventKey={'text'}>Text</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'media'}>Media</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'button'}>Button</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'iframe'}>Embed</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'shape'}>Shape</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'form'}>Forms</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'liveElements'}>Live Elements</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Tab.Content className={styles.tabContent}>
            <TextPalette editorSession={editorSession} defaultParent={defaultParent} />
            <MediaPalette editorSession={editorSession} defaultParent={defaultParent} />
            <ButtonPalette editorSession={editorSession} defaultParent={defaultParent} />
            <EmbedPalette editorSession={editorSession} defaultParent={defaultParent} />
            <AnchorPalette editorSession={editorSession} defaultParent={defaultParent} />
            <ShapePalette editorSession={editorSession} defaultParent={defaultParent} />
            <ContentGridPalette editorSession={editorSession} defaultParent={defaultParent} />
            <SectionPalette editorSession={editorSession} defaultParent={defaultParent} />
            <FormsPalette editorSession={editorSession} defaultParent={defaultParent} />
            <LiveElementsPalette editorSession={editorSession} defaultParent={defaultParent} active={activePane === 'liveElements'} />
          </Tab.Content >
        </div >
      </TabContainer >
    </PaletteContext.Provider >
  );
}

export function LiveElementPalette({ open, style, onClose, editorSession, defaultParent, target, ...rest }) {
  const [paletteContext, setPaletteContext] = React.useState({
    close: () => {
      onClose();
    }
  });

  const [activePane, setActivePane] = useState('text');

  return (
    <PaletteContext.Provider value={paletteContext}>
      <TabContainer id="widget_type_tabs" defaultActiveKey={'text'} transition={Fade} onSelect={(key) => {
        setActivePane(key);
      }}>
        <div className={styles.tabContainer}>
          <div className={styles.widgetTypes}>
            <Nav className={'flex-column'}>
              <Nav.Item>
                <Nav.Link eventKey={'text'}>Text</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'media'}>Media</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'button'}>Button</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'iframe'}>Embed</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'shape'}>Shape</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey={'form'}>Forms</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Tab.Content className={styles.tabContent}>
            <TextPalette editorSession={editorSession} defaultParent={defaultParent} />
            <MediaPalette editorSession={editorSession} defaultParent={defaultParent} target={target} />
            <ButtonPalette editorSession={editorSession} defaultParent={defaultParent} />
            <EmbedPalette editorSession={editorSession} defaultParent={defaultParent} />
            <AnchorPalette editorSession={editorSession} defaultParent={defaultParent} />
            <ShapePalette editorSession={editorSession} defaultParent={defaultParent} />
            <FormsPalette editorSession={editorSession} defaultParent={defaultParent} />
          </Tab.Content >
        </div >
      </TabContainer >
    </PaletteContext.Provider >
  );
}

const TextPalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const themes = useSelector(state => { return _.get(state, `${editorSession}.present.themes`) || [] })
  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);

  const handleCreateText = (data, themes) => {
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 600, height: 50 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 335, height: 50 });

    var themeContent = createThemeContent(data, themes);

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: TEXT,
            name: "Text",
            properties: {
              desktop: {
                visible: true,
                ...data.properties.desktop,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    rotate: "0deg",
                  },
                },
                alignment: 'left',
                lineSpacing: _.get(themes, 'font.lineSpacing', 1.2),
                letterSpacing: _.get(themes, 'font.letterSpacing', 0),
              },
              mobile: {
                visible: true,
                ...data.properties.mobile,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    rotate: "0deg",
                  },
                },
                alignment: 'left',
                lineSpacing: _.get(themes, 'font.lineSpacing', 1.2),
                letterSpacing: _.get(themes, 'font.letterSpacing', 0),
              },
            },
            content: themeContent,
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  const createThemeContent = (data, theme) => {
    const fontStyles = _.get(theme, 'font');
    const textStyles = _.get(theme, 'font.style');

    if (!fontStyles) {
      return data.content;
    }

    let themeContent = "";

    switch (true) {
      case (textStyles.bold && textStyles.italic):
        themeContent = `
          <${theme.type}>
            <span style="font-weight: bold; font-style: italic;">${theme.label}</span>
          </${theme.type}>
        `
        break;

      case (textStyles.bold):
        themeContent = `
          <${theme.type}>
            <span style="font-weight: bold;">${theme.label}</span>
          </${theme.type}>
        `
        break;

      case (textStyles.italic):
        themeContent = `
          <${theme.type}>
            <span style="font-style: italic;">${theme.label}</span>
          </${theme.type}>
        `
        break;

      default:
        themeContent = `
          <${theme.type} style="font-size:${fontStyles.fontSize}px">${theme.label}</${theme.type}>
        `
        break;
    }

    return themeContent;
  }

  return (
    <Tab.Pane eventKey="text" className={cx(styles.tabPane, styles.textPalette)}>
      {texts.map(text => {
        let textTheme = themes.find(data => data.type === text.id);

        var fontStyles = {
          fontFamily: _.get(textTheme, 'font.fontFamily', "Montserrat,sans-serif"),
          fontStyle: _.get(textTheme, 'font.style.italic', false) ? 'italic' : 'normal',
          fontWeight: _.get(textTheme, 'font.style.bold', false) ? 700 : 500
        }

        return (
          <div className={styles.widget} key={text.id} onClick={() => {
            handleCreateText(text.data, textTheme);
          }}>
            {text.render(fontStyles)}
          </div>
        );
      })}
    </Tab.Pane>
  );
}

const AnchorPalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });
  const breakpoint = useSelector(state => { return _.get(state, `${editorSession}.present.breakpoint`)})
  const parentLayout = _.get(parentWidget, `properties.${breakpoint}.layout`);

  const handleCreateAnchorWidget = () => {
    const position = getPositionForNewWidget(editorSession, parentLayout, { width: 1200, height: 50 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: ANCHOR,
            name: "Anchor",
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": `${position.x}px, ${position.y}px`,
                    "rotate": "0deg"
                  },
                  "width": "auto",
                  "height": "auto"
                }
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": `${position.x}px, ${position.y}px`,
                    "rotate": "0deg"
                  },
                  "width": "auto",
                  "height": "auto"
                }
              }
            },
            content: null,
          }
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <Tab.Pane eventKey="anchor" className={cx(styles.tabPane, styles.embedPalette)}>
      <div className={cx(styles.widget, styles.embed)} onClick={handleCreateAnchorWidget}>
        <i className={cx('cleverstory-anchor', styles.icon)}></i>
        <div className={styles.details}>
          <h5>Anchors</h5>
          <p>When you add an Anchor to a section, you can navigate to this section from anywhere on the page using hyperlinks or buttons</p>
        </div>
      </div>
    </Tab.Pane>
  );
}


const MediaPalette = ({ editorSession, defaultParent, target }) => {
  const dispatch = useDispatch();
  const [library, setLibrary] = useState(false);
  const [mediaType, setMediaType] = useState("image");
  const [mediaLibraryType, setMediaLibraryType] = useState("pexels");
  const [orientation, setOrientation] = useState("");
  const [activeState, setActiveState] = useState("manageMedia");

  const storyboardContext = React.useContext(StoryboardContext);
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });
  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);

  const handleUploadLibrary = () => {
    setLibrary(true);
  }

  const handleCreateImage = (medias) => {
    setLibrary(false);

    actionGroup.start();

    medias.forEach((media) => {
      const naturalWidth = _.get(media, 'width') || 600;
      const naturalHeight = _.get(media, 'height') || 600;

      var desktopWidth = Math.min(600, naturalWidth);
      var desktopHeight = desktopWidth * naturalHeight / naturalWidth;

      var mobileWidth = Math.min(300, naturalWidth);
      var mobileHeight = mobileWidth * naturalHeight / naturalWidth;

      const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: desktopWidth, height: desktopHeight });
      const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 300, height: desktopHeight });

      var widget = null;

      if (media.type === 'image') {
        widget = {
          type: IMAGE,
          name: "Image",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": `${desktopPosition.x}px, ${desktopPosition.y}px`,
                  "rotate": "0deg"
                },
                "width": `${desktopWidth}px`,
                "height": `${desktopHeight}px`
              },
              "crop": null,
              "alt": null,
              "animation": null,
              "border": null,
              "position": null,
              "shadow": null
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": `${mobilePosition.x}px, ${mobilePosition.y}px`,
                  "rotate": "0deg"
                },
                "width": `${mobileWidth}px`,
                "height": `${mobileHeight}px`
              },
              "crop": null,
              "alt": null,
              "animation": null,
              "border": null,
              "position": null,
              "shadow": null
            }
          },
          content: media
        }
      }

      if (media.type === 'video') {
        widget = {
          type: VIDEO,
          name: "Video",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": `${desktopPosition.x}px, ${desktopPosition.y}px`,
                  "rotate": "0deg"
                },
                "width": `${desktopWidth}px`,
                "height": `${desktopHeight}px`
              },
              "animation": null,
              "shadow": {
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "axes": {
                  "x": "0",
                  "y": "0",
                  "b": "0"
                },
                "show": false
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": `${mobilePosition.x}px, ${mobilePosition.y}px`,
                  "rotate": "0deg"
                },
                "width": `${mobileWidth}px`,
                "height": `${mobileHeight}px`
              },
              "animation": null,
              "shadow": {
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 1
                },
                "axes": {
                  "x": "0",
                  "y": "0",
                  "b": "0"
                },
                "show": false
              }
            }
          },
          content: media
        }
      }

      dispatch(createWidget(editorSession, [widget], defaultParent));
    });

    actionGroup.end();

    paletteContext.close();
  }

  const handleCloseMediaLibrary = () => {
    setLibrary(false);
  }

  const openMediaLibrary = (e) => {
    e.stopPropagation()
    handleUploadLibrary()
  }

  const handleManageMediaClick = () => {
    setActiveState("manageMedia");
  }

  const handleExternalMedia = () => {
    setActiveState("pexels");
  }


  return (
    <Tab.Pane eventKey="media" className={cx(styles.tabPane, styles.mediaPalette)}>
      <div className={styles.mediaManagement}>
        <Tab.Container id="regular-form-management-tab" defaultActiveKey="myMedia">
          <header className={styles.mediaManagementHeader}>
            <div className={styles.uploadMedia}>
              <MediaUploadButton className={styles.uploadMediaButton} storyboard={storyboardContext} target={target} mediaTypes={['image', 'video']}/>
            </div>

            <Nav variant="pills" className={styles.mediaManagementTab}>
              <Nav.Item>
                <Nav.Link eventKey="myMedia" onClick={handleManageMediaClick}>My Media</Nav.Link>
              </Nav.Item>
            </Nav>

            <hr />

            <div className={styles.headerTitle}>Stock Media</div>
            <Nav variant="pills" className={styles.mediaManagementTab}>
              <Nav.Item>
                <Nav.Link eventKey="pexels" onClick={handleExternalMedia}> Pexels </Nav.Link>
              </Nav.Item>
            </Nav>
            <section
              className={cx(styles.buttonContainer, styles.primaryActions)} >
            </section>
          </header>
          <Tab.Content className={styles.mediaContentContainer}>
            <Tab.Pane eventKey="myMedia">
              <MediaPaletteView
                mediaLibrary={library}
                multiple
                handleMediaLibrary={handleUploadLibrary}
                onSelect={handleCreateImage}
                storyboard={storyboardContext}
                target={target}
              />
              <MediaLibraryModal
                show={library}
                setLibrary = {setLibrary}
                storyboard={storyboardContext}
                target={target}
                editorSession = {editorSession}
                multiple
                onSelect={handleCreateImage}
                onClose={handleCloseMediaLibrary}
              />    
            </Tab.Pane>
            <Tab.Pane eventKey="pexels">
              <ExternalMediaPalette
                mediaLibrary={library}
                onSelect={handleCreateImage}
                onClose={handleCloseMediaLibrary}
                multiple
                handleMediaLibrary={handleUploadLibrary}
                mediaType = {mediaType}
                active = {activeState}
                orientation = {orientation}
                mediaLibraryType = {mediaLibraryType}
                editorSession = {editorSession}
                target={target}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </Tab.Pane>
  );
}

const ButtonPalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const breakpoint = useSelector(state => { return _.get(state, `${editorSession}.present.breakpoint`)})
  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);
  const handleCreateButton = (data) => {
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 260, height: 40 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 260, height: 40 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: BUTTON,
            name: "Button",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                visible: true,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                visible: true,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    rotate: "0deg",
                  }
                },
              },
            },
            content: data.content,
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <Tab.Pane eventKey="button" className={cx(styles.tabPane, styles.buttonPalette)}>
      <div className={styles.header}>Regular Buttons</div>
      <div className={styles.grid}>
        {buttons.map(button => {
          return (
            <div className={styles.widget} key={button.id} onClick={() => {
              handleCreateButton(button.data);
            }}>
              {button.render()}
            </div>
          );
        })}
      </div>
    </Tab.Pane>
  );
}

const EmbedPalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);

  const handleCreateIframeWidget = () => {
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 600, height: 400 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 260, height: 260 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: IFRAME,
            name: "IFRAME",
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "600px",
                  "height": "400px"
                }
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    "rotate": "0deg"
                  },
                  "width": "260px",
                  "height": "260px"
                }
              }
            }
          }
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  const handleCreateHtmlWidget = (iframe) => {
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 700, height: 260 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 260, height: 260 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: HTML,
            name: "HTML",
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    "rotate": "0deg"
                  },
                  "width": "700px",
                  "height": "260px"
                },
                "iframe": iframe
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    "rotate": "0deg"
                  },
                  "width": "260px",
                  "height": "260px"
                },
                "iframe": iframe
              }
            }
          }
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <Tab.Pane eventKey="iframe" className={cx(styles.tabPane, styles.embedPalette)}>
      <div className={cx(styles.widget, styles.embed)} onClick={handleCreateIframeWidget}>
        <i className={cx('cleverstory-content', styles.icon)}></i>
        <div className={styles.details}>
          <h5>Embed a site</h5>
          <p>Embed a website URL</p>
        </div>
      </div>
      <div className={cx(styles.widget, styles.embed)} onClick={() => handleCreateHtmlWidget(true)} >
        <i className={cx('cleverstory-html', styles.icon)}></i>
        <div className={styles.details}>
          <h5>Embed HTML</h5>
          <p>Embed a custom code within an iFrame</p>
        </div>
      </div>
      <div className={cx(styles.widget, styles.embed)} onClick={() => handleCreateHtmlWidget(false)} >
        <i className={cx('cleverstory-html', styles.icon)}></i>
        <div className={styles.details}>
          <h5>Embed HTML without iframe </h5>
          <p>Embed HTML code without an iFrame directly to your page</p>
        </div>
      </div>
    </Tab.Pane>
  );
}

const ShapePalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);

  const handleCreateLine = (data) => {
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 600, height: 50 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 100, height: 50 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: LINE,
            name: "Line",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                visible: true,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                visible: true,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    rotate: "0deg",
                  }
                }
              }
            }
          }
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  const handleCreateShape = (data, type) => {
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 600, height: 50 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 100, height: 50 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: type,
            name: "Shape",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    rotate: "0deg",
                  }
                },
              },
            },
            content: data.content,
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <Tab.Pane eventKey="shape" className={cx(styles.tabPane, styles.shapePalette)}>
      <div className={styles.header}>Lines</div>
      <div className={styles.lines}>
        {lines.map(shape => {
          const stroke = _.get(shape, 'data.properties.desktop.stroke');
          const type = _.get(shape, 'data.properties.desktop.type');

          return (
            <div className={cx(styles.widget, styles.line)} key={type} onClick={() => {
              handleCreateLine(shape.data);
            }}>
              <Widgets.Shapes.Line className={styles.lineShape} type={type} stroke={stroke} />
            </div>
          );
        })}
      </div>
      <div className={styles.header}>Basic Shapes</div>
      <div className={styles.grid}>
        {shapes.map(shape => {
          return (
            <div className={styles.widget} key={shape.id} onClick={() => {
              handleCreateShape(shape.data, shape.type);
            }}>
              {shape.render()}
            </div>
          );
        })}
      </div>
      <div className={styles.header}>Social Icons</div>
      <div className={styles.grid}>
        {socialIcons.map(socialicon => {
          return (
            <div className={styles.widget} key={socialicon.id} onClick={() => {
              handleCreateShape(socialicon.data, socialicon.type);
            }}>
              {socialicon.render()}
            </div>
          );
        })}
      </div>
      <div className={styles.header}>General Icons</div>
      <div className={styles.grid}>
        {generalIcons.map(generalicon => {
          return (
            <div className={styles.widget} key={generalicon.id} onClick={() => {
              handleCreateShape(generalicon.data, generalicon.type);
            }}>
              {generalicon.render()}
            </div>
          );
        })}
      </div>
    </Tab.Pane>
  );
}

const ContentGridPalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });
  const breakpoint = useSelector(state => { return _.get(state, `${editorSession}.present.breakpoint`)})

  const parentLayout = _.get(parentWidget, `properties.${breakpoint}.layout`);

  const handleContentGrid = (contentGridRequest) => {
    var data = _.cloneDeep(contentGridRequest);
    const position = getPositionForNewWidget(editorSession, parentLayout, { width: 260, height: 260 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: CONTENT,
            name: "Content",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                visible: true,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `0px, ${position.y}px`,
                    rotate: "0deg"
                  }
                },
              },
              mobile: {
                ...data.properties.mobile,
                visible: true,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: `0px, ${position.y}px`,
                    rotate: "0deg",
                  }
                },
              },
            },
            widgets: [...data.widgets],
            content: data.content
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  const handleInlineAsset =(assetRequest)=> {
    var data = _.cloneDeep(assetRequest);
    const position = getPositionForNewWidget(editorSession, parentLayout, { width: 260, height: 260 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: ASSET,
            name: "Inline Asset",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                visible: true,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `0px, ${position.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                visible: true,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: "0px, 0px",
                    rotate: "0deg",
                  }
                }
              },
            },
            content: data.content
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <Tab.Pane eventKey="content" className={cx(styles.tabPane, styles.contentGridPalette)}>
      <div className={styles.assetcardManagement}>
        <Tab.Container id="asset-management-tab" defaultActiveKey="static">
          <header className={styles.assetCardManagementHeader}>
            <Nav variant="pills" className={styles.assetCardManagementTab}>
              <Nav.Item>
                <Nav.Link eventKey="static">Static Cards</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="inline">In-Line Cards</Nav.Link>
              </Nav.Item>
            </Nav>
          </header>
          <Tab.Content className={styles.assetContentContainer}>
            <Tab.Pane className={styles.staticCards} eventKey="static">
              <div>
                {contentGrid.map((card) => {
                  return (
                    <div className={styles.cardHover} key={card.id} onClick={() => { handleContentGrid(card.data) }} >
                      {card.render()}
                    </div>
                  )
                })}
              </div>
            </Tab.Pane>
            <Tab.Pane className={styles.inlineCards} eventKey="inline">
              {inlineAssetCards.map((card, index) => {
                return (
                  <div className={styles.inlinecardHover} onClick={() => { handleInlineAsset(card.data) }}  key={card.id}>
                    <span className={styles.title} >{`${(index + 1)}.`} {card.name}</span>
                    {card.render()}
                  </div>
                )
              })}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </Tab.Pane>
  )
}

const SectionPalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const storyboardContext = React.useContext(StoryboardContext);
  const interactiveContent = _.get(storyboardContext, 'type') === 'INTERACTIVE_CONTENT';

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const breakpoint = useSelector(state => { return _.get(state, `${editorSession}.present.breakpoint`)})
  const parentLayout = _.get(parentWidget, `properties.${breakpoint}.layout`);

  const handleCreateSection = (data) => {
    const position = getPositionForNewWidget(editorSession, parentLayout, { width: 1200, height: 50 });
    const uid = `widget_${shortid.generate()}`;

    dispatch(
      createWidget(
        editorSession,
        [
          {
            ...data,
            uid: uid,
            properties: {
              desktop: {
                visible: true,
                ...data.properties.desktop,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `0px, ${position.y}px`,
                    rotate: "0deg",
                  }
                },
                stretched: data.properties.desktop.stretched && !interactiveContent
              },
              mobile: {
                ...data.properties.mobile,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: `0px, ${position.y}px`,
                    rotate: "0deg",
                  }
                }
              }
            },
            widgets: data.widgets.map(widget => {
              if (widget.type === SECTION_COLUMN) {
                const parentDesktopWidth = _.get(parentWidget, 'properties.desktop.container.minWidth');
                const parentMobileWidth = _.get(parentWidget, 'properties.mobile.container.minWidth');

                const desktopWidthPercent = parseFloat(_.get(widget, 'properties.desktop.layout.width'));
                const desktopWidth = desktopWidthPercent * parentDesktopWidth / 100;

                widget = _.cloneDeep(widget);
                _.set(widget, 'properties.desktop.container.minWidth', desktopWidth);
                _.set(widget, 'properties.mobile.container.minWidth', parentMobileWidth);

                return widget;
              }

              return widget;
            })
          }
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <Tab.Pane eventKey="section" className={cx(styles.tabPane, styles.textPalette)}>
      {sections.map(section => {
        return (
          <div className={styles.widget} key={section.id} onClick={() => {
            handleCreateSection(section.data);
          }}>
            {section.render()}
          </div>
        );
      })}
    </Tab.Pane>
  );
}

const FormsPalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(state => _.get(state, `forms.loading`, false));
  const pagination = useSelector(state => _.get(state, 'forms.pagination', {}));
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;
  const integrationTypes = _.filter(INTEGRATION_TYPES, { forms: true });
  const activatedIntegrations = useSelector(state => _.get(state, 'integrations.activated.items', []));

  const sortIntegrations = () => {
    const integrationOrder = _.map(integrationTypes, 'type');
    const filteredList = _.filter(activatedIntegrations, item => _.includes(integrationOrder, item.type))

    return _.sortBy( filteredList, item => _.indexOf(integrationOrder, item.type));
  };

  let activeIntegrations = sortIntegrations();

  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const createdForms = useSelector(state => _.get(state, `forms.items`, null));

  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);

  const handleCreateForm = (data) => {
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 600, height: 415 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 335, height: 463 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: FORM,
            name: "Form",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    rotate: "0deg",
                  }
                }
              },
            },
            widgets: data.widgets,
            content: data.content
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  const handleManageForms = () => {
    const url = `${baseUrl}/integration-settings/forms`;
    history.push(url);
  }

  const production = process.env.NODE_ENV === 'production';
  const imageId = production ? "62e3ab81dbfd3e6ec4a2a133" : "62de5538833d8a337666b497";

  const handleCreateExternalForm = (form, data) => {

    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 600, height: 415 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 335, height: 463 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: EXTERNAL_FORM,
            name: "Form",
            properties: {
              desktop: {
                visible: true,
                layout: {
                  transform: {
                    translate: `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    rotate: "0deg"
                  },
                  width: '600px',
                  height: `415px`
                },
                border: null,
                background: {
                  r: 245,
                  g: 245,
                  b: 245,
                  a: 1
                }
              },
              mobile: {
                visible: true,
                layout: {
                  transform: {
                    translate: `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    rotate: "0deg"
                  },
                  width: '335px',
                  height: `463px`
                }
              }
            },
            order: 1,
            widgets: [{
              type: FORM_STEP,
              name: "Success",
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: `0px, 0px`,
                      rotate: "0deg"
                    }
                  }
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: `0px, 0px`,
                      rotate: "0deg"
                    }
                  }
                }
              },
              widgets: [
                {
                  type: TEXT,
                  name: "Form Title",
                  properties: {
                    "desktop": {
                      "visible": true,
                      "layout": {
                        "transform": {
                          "translate": "30px,268px",
                          "rotate": "0deg",
                          "scale": "1,1"
                        },
                        "width": "353.461px",
                        "height": "auto"
                      },
                      "fontSize": "16",
                      "lineSpacing": "1.2",
                      "letterSpacing": "0",
                      "color": null,
                      "alignment": "left",
                      "animation": null
                    },
                    "mobile": {
                      "visible": true,
                      "layout": {
                        "transform": {
                          "translate": "20px,336.00048828125px",
                          "rotate": "0deg",
                          "scale": "1,1"
                        },
                        "width": "261px",
                        "height": "auto"
                      },
                      "fontSize": "32",
                      "lineSpacing": "1.2",
                      "letterSpacing": "0",
                      "color": null,
                      "alignment": "left",
                      "animation": null
                    }
                  },
                  content: '<h3><strong>Thanks </strong></h3>\n<h3><strong>for submitting!</strong></h3>'
                }, {
                  type: TEXT,
                  name: "Form Title",
                  properties: {
                    "desktop": {
                      "visible": true,
                      "layout": {
                        "transform": {
                          "translate": "30px, 360px",
                          "rotate": "0deg",
                          "scale": "1,1"
                        },
                        "width": "auto",
                        "height": "auto"
                      },
                      "fontSize": "16",
                      "lineSpacing": "1.2",
                      "letterSpacing": "0",
                      "color": null,
                      "alignment": "left",
                      "animation": null
                    },
                    "mobile": {
                      "visible": true,
                      "layout": {
                        "transform": {
                          "translate": "20px, 415px",
                          "rotate": "0deg",
                          "scale": "1,1"
                        },
                        "width": "238.4921875px",
                        "height": "auto"
                      },
                      "fontSize": "16",
                      "lineSpacing": "1.2",
                      "letterSpacing": "0",
                      "color": null,
                      "alignment": "left",
                      "animation": null
                    }
                  },
                  content: '<p>We’ll get back to you shortly :)</p>'
                },
                {
                  "type": "cleverstory.v2.widgets.image",
                  "name": "Image",
                  "capabilities": null,
                  "order": 1,
                  "fonts": null,
                  "actions": null,
                  "properties": {
                    "desktop": {
                      "visible": true,
                      "shadow": {
                        "color": {
                          "r": 255,
                          "g": 255,
                          "b": 255,
                          "a": 1
                        },
                        "axes": {
                          "x": 0,
                          "y": 0,
                          "b": 0
                        },
                        "show": false
                      },
                      "layout": {
                        "transform": {
                          "translate": "198.0000000000001px,48.99999999999969px",
                          "rotate": "0deg",
                          "scale": "1,1"
                        },
                        "width": "317px",
                        "height": "274.961px"
                      },
                      "crop": null,
                      "alt": null
                    },
                    "mobile": {
                      "visible": true,
                      "layout": {
                        "transform": {
                          "translate": "20px,20px",
                          "rotate": "0deg"
                        },
                        "width": "295px",
                        "height": "256.0584635416667px"
                      },
                      "crop": null,
                      "alt": null
                    }
                  },
                  "content": {
                    "id": imageId,
                    "contentType": "image/png",
                    "type": "image",
                    "width": 500.0,
                    "height": 434.0,
                    "url": `public/cleverstory/v2/media/images/${imageId}/thankyou.png`
                  }
                },
              ],
              order: 2,
            }
            ],
            content: form
          }
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }

    dispatch(fetchCreatedForms(nextPage, 20, "hubspot"));
  }

  useEffect(() => {
    dispatch(fetchCreatedForms(0, 20, "hubspot"));
  }, []);

  const RenderFormName = ({ id, formName }) => {
    const [tooltip, setTooltip] = useState(false);

    const handleTooltip = (isTruncated) => {
      setTooltip(isTruncated)
    }

    return (
      <Tooltip key={id} placement="top" content={formName} disabled={!tooltip}>
        <Truncate lines={1} width={140} ellipsis="..." onTruncate={handleTooltip}>
          {formName}
        </Truncate>
      </Tooltip>
    )
  }

  const ExternalForms = ({ formType }) => {
    const forms = createdForms.filter(item => {
      return item.type == formType;
    });

    return (
      <>
        <div className={styles.manageForm}>
          <Button variant="primary"
            onClick={handleManageForms}
            className={styles.actionButton}>
            Manage Forms
          </Button>
        </div>
        <InfiniteScroll
          loading={loading}
          hasMore={hasMoreItems}
          loadMore={loadMore}
        >
          <div className={styles.formsCardContainer}>
            {loading && forms.length == 0 &&
             <div className={styles.loadingMessage}>Loading Forms...</div>
            }

            {!loading && forms && forms.length == 0 &&
              <div className={styles.emptyMessage}>
                No Forms Found in your Supplies
              </div>
            }
            {!loading && forms && forms.map(form => {
              return (
                <div>
                  <div className={styles.formsCard} key={form.id} onClick={() => handleCreateExternalForm(form, {})}>
                    <img src="/images/forms/formPreview.svg" alt="" />
                  </div>
                  <div className={styles.formName}>
                    <RenderFormName id={form.id} formName={form.name} />
                  </div>
                </div>
              )
            })}
          </div>
        </InfiniteScroll>
      </>
    )
  }

  return (
    <Tab.Pane eventKey="form" className={cx(styles.tabPane, styles.formsPalette)}>
      <div className={styles.formManagement}>
        <Tab.Container id="regular-form-management-tab" defaultActiveKey="general">
          <header className={styles.formManagementHeader}>
            <div className={styles.headerTitle}>REGULAR FORMS</div>

            <Nav variant="pills" className={styles.formManagementTab}>
              <Nav.Item>
                <Nav.Link eventKey="general">General</Nav.Link>
              </Nav.Item>
            </Nav>

            <>
              <div className={styles.headerTitle}>EXTERNAL FORMS</div>
              <Nav variant="pills" className={styles.formManagementTab}>
                {activeIntegrations.length > 0 && activeIntegrations.map((integration)=>{
                  return(
                    <Nav.Item>
                      <Nav.Link eventKey={integration.type}>
                        <div className={styles.logoContainer}>
                          <Image src={`/images/integrations/${integration.type}.png`} />
                          <div id="#contact_form"></div>
                        </div>
                        {integration.type}
                      </Nav.Link>
                    </Nav.Item>
                    )
                  })
                }

                {
                  <Nav.Item>
                    <Nav.Link eventKey={'external'}>
                      <div className={styles.logoContainer}>
                        <Image src={`/images/forms/external_form.svg`} />
                      </div>
                      external
                    </Nav.Link>
                  </Nav.Item>
                }
              </Nav>
            </>
          </header>
          <Tab.Content className={styles.formContentContainer}>
            <Tab.Pane eventKey="general">
              <div>{forms.map((form, index) => {
                return (
                  <div className={styles.widget} key={index} onClick={() => {
                    handleCreateForm(form.data);
                  }}>
                    {form.render()}
                  </div>)
              })}</div>
            </Tab.Pane>
            <Tab.Pane eventKey="hubspot">
              <ExternalForms formType={"hubspot"} />
            </Tab.Pane>
            <Tab.Pane eventKey="marketo">
              <ExternalForms formType={"marketo"} />
            </Tab.Pane>
            <Tab.Pane eventKey="pardot">
              <ExternalForms formType={"pardot"} />
            </Tab.Pane>
            <Tab.Pane eventKey="external">
              <ExternalForms formType={"external"} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </Tab.Pane>
  );
}


const CarouselPalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const parentLayout = _.get(parentWidget, 'properties.desktop.layout');

  const handleCreateCarousel = (data) => {
    const position = getPositionForNewWidget(editorSession, parentLayout, { width: 1200, height: 250 });
    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: CAROUSEL,
            name: "Carousel",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                visible: true,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `${position.x}px, ${position.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                visible: true,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: "0px, 20px",
                    rotate: "0deg",
                  }
                }
              },
            },
            widgets: data.widgets,
            content: data.content
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <Tab.Pane eventKey="carousel" className={cx(styles.tabPane, styles.carouselPalette)}>
      <div className={styles.details}>
        <h5 className={styles.header}>Carousel</h5>
      </div>
      {carousels.map((carousel, index) => {
        return (
          <div key={index} className={styles.widget} onClick={() => handleCreateCarousel(carousel.data)}>
            {carousel.render()}
          </div>
        );
      })}
    </Tab.Pane>
  );
}

const Seek = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });
  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);

  const handleCreateSeekBar = (data) => {
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 1200, height: 55 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 375, height: 55 });

    const type = _.get(data, 'properties.desktop.questionDesign.type', 'bar');
    const defaultPosition = _.get(data, 'properties.desktop.layout.transform', {
      translate: "0px, 20px",
      rotate: "0deg"
    });
    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: SEEK,
            name: "Seek",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                visible: true,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: type == 'button' ? `${defaultPosition.translate}` : `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                visible: true,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: type == 'button' ? `${defaultPosition.translate}` : `0px, ${mobilePosition.y}px`,
                    rotate: "0deg",
                  }
                }
              },
            },
            widgets: data.widgets,
            content: data.content
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <Tab.Pane eventKey="seek" className={cx(styles.tabPane, styles.seekPalette)}>
      <div className={styles.seekHeader}>
        <div className={styles.logoContainer}>
          <span className={styles.seekLogo}>seek</span>
          <span className={styles.seekSubText}>Powered by Open AI</span>
        </div>
      
        <a className={styles.knowMore} href='https://experiences.cleverstory.io/introducing-seek' target='_blank'>
          <i className={cx(styles.icon, "cleverstory-url")} />
          <span>Know More</span>
        </a>
      </div>

      <div className={styles.seekBarsContainer}>
        <span className={styles.title}>Seek Bar</span>
        <div className={styles.barsContainer}>
          {seekBars.map((seekbar, index) => {
            return (
              <div key={index} className={styles.widget} onClick={() => handleCreateSeekBar(seekbar.data)}
              >
                {seekbar.render()}
              </div>
            );
          })}
        </div>
      </div>

      {/* <div className={styles.seekBtnsContainer}>
        <span className={styles.title}>Seek Button</span>
        <div className={styles.buttonsContainer}>
          {seekButtons.map((seekButton, index) => {
            return (
              <div key={index} className={styles.widget} 
              onClick={() => handleCreateSeekBar(seekButton.data)}
              >
                {seekButton.render()}
              </div>
            );
          })}
        </div>
      </div> */}
    </Tab.Pane>
  );
}

const MenusPalette = ({ editorSession, defaultParent }) => {
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const parentLayout = _.get(parentWidget, 'properties.desktop.layout');

  const handleCreateMenu = (data) => {
    const position = getPositionForNewWidget(editorSession, parentLayout, { width: 1200, height: 40 });
    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: MENU,
            name: "Menu",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                visible: true,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: `${position.x}px, ${position.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                visible: true,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: "0px, 20px",
                    rotate: "0deg",
                  }
                }
              },
            },
            widgets: data.widgets,
            content: data.content
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  }

  return (
    <Tab.Pane eventKey="Menu" className={cx(styles.tabPane, styles.menuPalette)}>
      {menus.map((menu, index) => {
        return (
          <div key={index} className={styles.widget} onClick={() => handleCreateMenu(menu.data)}>
            {menu.render()}
          </div>
        );
      })}
    </Tab.Pane>
  );
}